// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__QSzGx","title":"AfterFrontImage_title__nhmQ3"};